import React from 'react'
import '../style.css'
import FormRegister from './components/FormRegister'

const Register = () => {
  return (
    <section id='register'>
        <div className="container">
          <h1 className='text-center'><b>Form Registrasi</b></h1>
          <div className="form">
            <FormRegister />
          </div>
        </div>
    </section>
  )
}

export default Register